export const CategoryFilter = ({ categories, active, onChange }) => {
  return (
    <div
      data-testid="category-filter"
      className="border-y border-[#2D2622]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 overflow-x-auto">
        <div className="flex items-center gap-8 md:gap-10 py-5 min-w-max">
          {categories.map((cat) => {
            const isActive = active === cat;
            const slug = cat.toLowerCase().replace(/\s+/g, "-");
            return (
              <button
                key={cat}
                data-testid={`category-filter-${slug}`}
                onClick={() => onChange(cat)}
                className={`text-[11px] tracking-overline uppercase font-bold whitespace-nowrap transition-colors ${
                  isActive
                    ? "text-[#F4EAD9] active-cat"
                    : "text-[#D4AF37] hover:text-[#F4EAD9]"
                }`}
              >
                {cat}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CategoryFilter;
